import FormErrors from './FormErrors';
import get from 'lodash/get';
import set from 'lodash/set';
import ShowNotificationMixin from "../../mixins/ShowNotificationMixin";

export default {
    components: {FormErrors},
    data() {
        return {
            formErrors: {},
        };
    },
    mixins: [ShowNotificationMixin],
    methods: {
        setformErrors(errors = {}) {
            this.formErrors = errors;
        },
        async catchAppResourceErrors(callback, flag, fallback) {
            try {
                if (typeof flag !== 'undefined') {
                    this.$nextTick(() => {
                        set(this, flag, true);
                    });
                }

                await callback();
            } catch (e) {
                const validationErrors = get(e, 'response.data.errors');

                if (validationErrors) {
                    return this.setformErrors(validationErrors);
                }

                const isServerError = get(e, 'response.status') === 500;

                if (isServerError) {
                    this.showNotification({
                        message: `Please try again later!`
                    });
                }

                if (fallback) {
                    await fallback(validationErrors);
                }
                throw e;
                return false;
            } finally {
                if (typeof flag !== 'undefined') {
                    this.$nextTick(() => {
                        set(this, flag, false);
                    });
                }
            }

            return true;
        },
    },
};
